import React, { useState, useEffect } from "react";
import { BounceLoader } from "react-spinners";

type LoadingProps = {
  loading: boolean;
  desc?: string;
};

const Loading: React.FC<LoadingProps> = ({ loading, desc }) => {
  const loadingMessages = [
    "Fetching data...",
    "Few seconds more...",
    "Almost there...",
    "Finishing request...",
  ];
  const [loadingText, setLoadingText] = useState(loadingMessages[0]);

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        const randomIndex = Math.floor(Math.random() * loadingMessages.length);
        setLoadingText(loadingMessages[randomIndex]);
      }, 5000); // Change text every 2 seconds

      return () => clearInterval(interval); // Clean up on unmount
    }
  }, [loading]);

  if (!loading) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen flex flex-col items-center justify-center z-50 bg-white">
      <BounceLoader
        color={"#2ff77a"}
        loading={loading}
        size={60}
        speedMultiplier={1}
      />
      <p className="mt-4 text-center font-Inter animate-pulse text-midGreen text-lg">{desc ? desc : loadingText}</p>
    </div>
  );
};

export default Loading;
